import type { ClientChat } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { QueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';

const getCachedChatsByParticipant = (
  queryClient: QueryClient,
  personId: string
): ClientChat[] => {
  const data = queryClient
    .getQueriesData<ClientChat>({
      queryKey: [API_CACHE_KEYS.CHAT]
    })
    .map((entry) => entry[1])
    .filter((chat) => chat !== undefined)
    .filter((chat) =>
      chat.chatParticipants?.some(
        (participant) => participant.person?.id === personId
      )
    );
  return data;
};

export const invalidateChatCachesForPerson = (
  queryClient: QueryClient,
  personId: string
) => {
  queryClient.invalidateQueries({
    queryKey: [API_CACHE_KEYS.OWN_CHATS]
  });
  const affectedChats = getCachedChatsByParticipant(queryClient, personId);
  for (const chat of affectedChats) {
    queryClient.invalidateQueries({
      queryKey: [API_CACHE_KEYS.CHAT, chat.id]
    });
  }
};
